window.$ = window.jQuery = require('jquery');

import "jquery-ui/ui/widgets/datepicker";

function Datepicker(el, index) {
    this.el = el;
    this.index = index;
    this.id = el.id;
    this.initEvents();
}
Datepicker.prototype = {
    initEvents: function () {
        var _this = this;

        var picker = {
            altField: _this.id,
            altFieldTimeOnly: false,
            // autoclose: true,
            defaultDate: "+1w",
            numberOfMonths: 1,
            dateFormat: "dd.mm.y"
        }
        _this.el.datepicker(picker);

    }
}
export default Datepicker;
